module.exports = __webpack_public_path__ + "static/media/phone-bussnis.e3b34cd5.png";